import React from 'react';
import type { ThesisPillar } from '../types';

export interface ContentItemProps {
  pillar: ThesisPillar;
  index: number;
  isActive?: boolean;
}

export function ContentItem({ pillar, index, isActive = false }: ContentItemProps) {
  return (
    <div 
      className={`
        relative pl-6 transition-opacity duration-300
        ${isActive ? 'opacity-100' : 'opacity-40'}
      `}
    >
      {/* Left accent bar */}
      <div 
        className={`
          absolute left-0 top-0 bottom-0 w-px 
          transition-all duration-300
          ${isActive ? 'bg-foreground/30' : 'bg-border/30'}
        `}
      />
      
      {/* Number */}
      <div className="text-label font-mono mb-2 text-foreground-muted">
        0{index + 1}
      </div>

      {/* Title */}
      <h3 className={`
        font-display text-heading-lg mb-2 transition-colors duration-300
        ${isActive ? 'text-foreground' : 'text-foreground-muted'}
      `}>
        {pillar.title}
      </h3>

      {/* Description */}
      <p className="font-body text-body-sm text-foreground-tertiary leading-relaxed">
        {pillar.description}
      </p>
    </div>
  );
}

export default ContentItem;
